import 'react-datepicker/dist/react-datepicker.css';

import { Box, Flex, FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { forwardRef, MouseEventHandler, ReactNode } from 'react';
import DatePicker from 'react-datepicker';
import { FiCalendar, FiChevronDown } from 'react-icons/fi';

import {
  PLAN_REVAMP_RADIUS_SM,
  PLAN_TEXT,
  controlHeight,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';
import { fontSize } from 'styles/revampTokens';

import colors from '../../dataTheme';

import datePickerStyle from './style';

interface Properties {
  value?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  planPermission?: boolean;
}

const DatePickerInput = forwardRef<HTMLDivElement, Properties>(({ value, onClick }, reference) => (
  <Flex
    role='button'
    tabIndex={0}
    ref={reference}
    onClick={onClick}
    alignItems='center'
    gap={2}
    w='100%'
    h={controlHeight}
    px='10px'
    border='1px solid'
    borderColor={colors.border}
    borderRadius={PLAN_REVAMP_RADIUS_SM}
    bg={colors.surface}
    {...PLAN_TEXT.body}
    fontSize={fontSize.body}
    color={colors.textDark}
    transition='background 0.12s ease, border-color 0.12s ease'
    _hover={{ bg: colors.hover }}
  >
    <FiCalendar size={14} color={colors.textSecondary} />
    <Box flex={1} textAlign='left'>
      {value}
    </Box>
    <FiChevronDown size={14} color={colors.textSecondary} />
  </Flex>
));

const DataDatePicker = ({
  selected,
  onChange,
  placeholder,
  label,
  errorMessage,
  timescale,
  onSelect,
  clearDateInput,
  dateId,
  startIn,
  endIn,
  deleteStart,
  clearSection = true,
  isDisabled,
}: any) => {
  return (
    <FormControl sx={datePickerStyle} data-testid='datePicker-test'>
      {label && <FormLabel>{label}</FormLabel>}

      <DatePicker
        data-testid='datePicker-test'
        selected={selected}
        onChange={onChange}
        disabled={isDisabled}
        placeholderText={placeholder}
        dateFormat={timescale === 'Y' ? 'yyyy' : 'MMM yyyy'}
        showMonthYearPicker={timescale === 'M'}
        showYearPicker={timescale === 'Y'}
        customInput={<DatePickerInput />}
        onSelect={onSelect}
      >
        {clearSection && (
          <Flex
            marginBottom='15px'
            borderTop='1px solid rgba(112, 138, 138, 0.3)'
            width='90%'
            display='flex'
            justifyContent='center'
            alignItems='center'
            paddingTop='10px'
            color='purple'
            onClick={() => {
              clearDateInput(dateId, deleteStart, startIn, endIn);
            }}
          >
            <Box>Clear Selection</Box>
          </Flex>
        )}
      </DatePicker>

      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};

export default DataDatePicker;
